import { NavigationGuardNext, Route } from 'vue-router'
import store from '@/store'

function dashboardApiAddonGuard(to: Route, from: Route, next: NavigationGuardNext): void {
  if (store.getters['subscription/isDashboardApiPurchased']) {
    return next()
  }

  return next({ name: 'error-404' })
}

export default dashboardApiAddonGuard
